import { saveAs } from "file-saver";
import { ENUM_CURRENCY } from "../../../enums";
import { convertToFullName, numberFormat } from "../../../services/utils";

function escapeCsvValue(value) {
  if (value == null) return "";
  const str = String(value);
  if (str.includes(",") || str.includes('"') || str.includes("\n")) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function convertToCsv(headers: string[], rows: string[][]) {
  const lines = [
    headers.map(escapeCsvValue).join(","),
    ...rows.map((row) => row.map(escapeCsvValue).join(",")),
  ];
  return lines.join("\n");
}

const CLIENT_EXPORT_HEADERS = [
  "Name",
  "Email",
  "Company",
  "Title",
  "Founder",
  "Co Founder",
  "No of emp",
  "Company Value Proposition",
  "Budget",
  "Balance",
];

function mapClientToExportRow(client) {
  return [
    convertToFullName(client.firstName, client.lastName),
    client.email || "",
    client.company || "",
    client.title || "",
    client.founderName || "",
    client.coFounderName || "",
    client.no_of_emp || "",
    client.other_info || "",
    numberFormat(client.budget, ENUM_CURRENCY.USD) || "",
    numberFormat(client.balance, ENUM_CURRENCY.USD) || "",
  ];
}

function downloadClientListCsv(clients: any[] = []) {
  const csvContent = convertToCsv(
    CLIENT_EXPORT_HEADERS,
    clients.map(mapClientToExportRow)
  );
  const blob = new Blob(["\uFEFF" + csvContent], {
    type: "text/csv;charset=utf-8;",
  });
  const date = new Date().toISOString().slice(0, 10);
  saveAs(blob, `clients-${date}.csv`);
}

export { downloadClientListCsv };
